import { useEditor } from "@smartfire/js-block-engine";
import {
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
} from "@mui/icons-material";
import clsx from "clsx";
import { useCallback, useMemo, useRef } from "react";
import { useHorizontalScroll, useIntersect } from "../../hooks";
import style from "./style.module.scss";

export const SubMenu = ({
  arrowLeftBgColor,
  arrowRightBgColor,
  className,
  children,
  showInAdmin = false,
}) => {
  const { isEditing } = useEditor();
  const arrowLeftRef = useRef();
  const arrowRightRef = useRef();
  const targetLeftRef = useRef();
  const targetRightRef = useRef();
  const scrollableDivRef = useRef();
  const { startScrolling } = useHorizontalScroll(scrollableDivRef);

  const ratio = useMemo(() => 0.9, []);

  const callbackIntersect = useCallback(
    (entry, ref) => {
      if (entry.intersectionRatio >= ratio) {
        ref.current.classList.add(style.hide);
      } else {
        ref.current.classList.remove(style.hide);
      }
    },
    [ratio]
  );
  const callbackIntersectLeft = useCallback(
    (entry) => callbackIntersect(entry, arrowLeftRef),
    [arrowLeftRef, callbackIntersect]
  );
  const callbackIntersectRight = useCallback(
    (entry) => callbackIntersect(entry, arrowRightRef),
    [arrowRightRef, callbackIntersect]
  );

  useIntersect(targetLeftRef, callbackIntersectLeft, ratio);
  useIntersect(targetRightRef, callbackIntersectRight, ratio);

  return isEditing && !showInAdmin ? null : (
    <div className={style.subMenu}>
      {!(isEditing && showInAdmin) && (
        <div
          ref={arrowLeftRef}
          className={clsx(style.scrollArrow, style.arrowLeft)}
          style={{ "--arrow-bg-color": arrowLeftBgColor }}
          onMouseDown={() => startScrolling("left")}
          onTouchStart={() => startScrolling("left")}
        >
          <ArrowBackIcon />
        </div>
      )}

      <div className={style.overflow} ref={scrollableDivRef}>
        <div className={clsx(style.overflowContainer, className)}>
          <div
            ref={targetLeftRef}
            className={clsx(style.intersectTarget, style.targetLeft)}
          />

          {children}

          <div
            ref={targetRightRef}
            className={clsx(style.intersectTarget, style.targetRight)}
          />
        </div>
      </div>

      {!(isEditing && showInAdmin) && (
        <div
          ref={arrowRightRef}
          className={clsx(style.scrollArrow, style.arrowRight)}
          style={{
            "--arrow-bg-color": arrowRightBgColor || arrowLeftBgColor,
          }}
          onMouseDown={() => startScrolling("right")}
          onTouchStart={() => startScrolling("right")}
        >
          <ArrowForwardIcon />
        </div>
      )}
    </div>
  );
};
